import type { MouseEvent } from 'react';

import type { Data, NoData } from './types.js';
import { interactionsOverlay } from '../interactions-overlay/InteractionsOverlay.sty.js';

export const emptyData: () => NoData = () => ({
  header1: undefined,
  subheader: undefined,
  series: undefined,
  geometry: 'none',
});

export const isTooltipDataEmpty = (data: Data | NoData) =>
  data.geometry === 'none';

export const isOwnEvent = (event: MouseEvent) => {
  const target = event.target as HTMLElement | null;
  return target?.classList?.contains(interactionsOverlay);
};
